export class Grupo {
	constructor(
		public id: number,
		public rol_id: number,
		public nombre: string,
		public apellidos: string,
		public email: string,
		public telefono: string,
		public password: string,
		public re_password: string,
		public remember_token: string,
		public estatus: string,
		public active: number
	) { }
}